import { createFeatureSelector, createSelector } from '@ngrx/store'

import { CATEGORIES_FEATURE_KEY, State, categoriesAdapter } from './categories.reducer'

// Lookup the 'Categories' feature state managed by NgRx
export const getCategoriesState = createFeatureSelector<State>(CATEGORIES_FEATURE_KEY)

const { selectAll, selectEntities, selectIds } = categoriesAdapter.getSelectors()

export const getCategoriesLoaded = createSelector(getCategoriesState, (state: State) => state.loaded)

export const getCategoriesError = createSelector(getCategoriesState, (state: State) => state.error)

export const getAllCategories = createSelector(getCategoriesState, (state: State) => selectAll(state))

export const getAllCategoriesIds = createSelector(getCategoriesState, (state: State) => selectIds(state))

export const getCategoriesEntities = createSelector(getCategoriesState, (state: State) => selectEntities(state))

export const getSelectedId = createSelector(getCategoriesState, (state: State) => state.selectedId)

export const getSelected = createSelector(getCategoriesEntities, getSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const getCategoriesCount = createSelector(getCategoriesState, (state) => state.count)

export const getStalePages = createSelector(getCategoriesState, (state) => state.stale)

export const getCategoryById = (uuid: string) => createSelector(getCategoriesEntities, (entities) => entities[uuid])
